export default {"src":"/_next/static/media/Como.c8583efd.svg","height":500,"width":484,"blurWidth":0,"blurHeight":0};